import React, {useState} from 'react'
import ImageUploadCtn from '../imageUploadFrame'
import ImageAvatarField from '../../components/ImageAvatarField'
import profile_icon from '../../assets/images/icons/profile-icon.png'
import star_icon from '../../assets/images/icons/star-icon.png'
import ImageCropModal from '../../components/ImageCropModel'
import PopupModel from '../models/popupModel'







const CompanyProfile = (props)=>{

   const {
       title, 
       required, 
       applicationDetails, 
       tempAvatarImage, 
       setTempAvatarImage,
       croppedImagePath,
       setCroppedImagePath,
       isCropImageModalVisible,
       setIsCropImageModalVisible } = props


    const [showModel, setModel] = useState(false)

    return(
        <div className="dashboard-textfield-container">
            <div className="dashboard-textfield-title">
                <span className="general-span-text">{title}</span>
                {required && <div>
                        <img src={star_icon}/>
                    </div>}
            </div>
            <div className="dashboard-textfield-input">
                <div className="upload-phot-ctn">
                    <ImageUploadCtn
                                style={{width: '80%',display: 'flex', flexDirection: 'column', padding: '20px 0px'}}
                                onImageRejected={() => {
                                    setModel(true)
                                }}
                                onImageAccepted={(files) => {
                                if (files.length > 0) {
                                    console.log("the file we receive", files)
                                    setTempAvatarImage(files[0]);
                                    setIsCropImageModalVisible(true);
                                }
                                }}
                                >
                                 <ImageAvatarField avatarUrl={
                                    croppedImagePath || 
                                    `data:image/${applicationDetails.portraitPhotoFile?.type};base64,${applicationDetails.portraitPhotoFile?.fileText}` ||
                                    profile_icon}/>
                            {croppedImagePath === undefined && applicationDetails.portraitPhotoFile === null ?<span style={{textAlign: 'center'}}>
                                Drop file to <br/> Upload <br/> 
                                <span className="or-text"> or </span><br/> Browse
                            </span> : null}
                    </ImageUploadCtn>
                </div>
            </div>
            <ImageCropModal
                imagePath={tempAvatarImage
                    ? URL.createObjectURL(tempAvatarImage)
                    : ''}
                    onCropSelected={(croppedImage) => {
                    setCroppedImagePath(croppedImage);
                    setIsCropImageModalVisible(false)
                }}
                    isVisible={isCropImageModalVisible}
                    handleHide={() => {
                    setIsCropImageModalVisible(false)
                }}/>
            <PopupModel
                show={showModel}
                hide={()=>setModel(false)}
                content="Portrait image should not exceed 4mbs"
                btnText="Ok"
                handleConfirm={()=>setModel(false)}
                />
        </div>

    )
}

export default CompanyProfile